import { env } from '@cc-shopping/platform-env';
import type { SDKConfig } from '../types/absmartly';
import { getABSmartlyEnvironment } from '../utils/getABSmartlyEnvironment';

export const abSmartlySDKConfig: SDKConfig = {
  environment: getABSmartlyEnvironment(),
  application: 'cc-shopping-client',
  apiKey: env.NEXT_PUBLIC_ABSMARTLY_API_KEY,
  endpoint: env.NEXT_PUBLIC_ABSMARTLY_URL,
};
